import {AnyAction} from 'redux'
import {GET_ORDER} from '../actions/placed-order'
import {SEND_RSVP} from '../actions/rsvp'

export const calendarLinks = (state = null, action: AnyAction) => {
  switch (action.type) {
    case SEND_RSVP.SUCCESS:
    case GET_ORDER.SUCCESS:
      return {
        ...action.payload.calendarLinks,
      }
    default:
      return state
  }
}
